import React, { useState, useEffect } from "react";
import apiCall from "../../API/API";
import { toast } from "react-toastify";
import { Row, Col, Container, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";

const UpdateBonusIncome = () => {
  const [type, setType] = useState("roi_income");
  const [income, setIncome] = useState("");

  useEffect(() => {
    const fetchAllPackage = async () => {
      try {
        const { data, error } = await apiCall("GET", "/getAllPackage");
        if (data) {
          console.log("getAllPackage API Response:", data);
          // Extract income value from roi_income
          if (data.packages && data.packages.length > 0 && data.packages[0].roi_income) {
            const roiIncomeValue = data.packages[0].roi_income.income;
            if (roiIncomeValue !== undefined && roiIncomeValue !== null) {
              setIncome(roiIncomeValue.toString());
            }
          }
        } else if (error) {
          console.error("getAllPackage API Error:", error);
        }
      } catch (error) {
        console.error("getAllPackage API Exception:", error);
      }
    };
    fetchAllPackage();
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!income || income === "") {
      toast.error("Please enter income value");
      return;
    }

    try {
      const body = {
        type: type,
        income: parseFloat(income),
      };
      console.log("body", body);
      const { data, error } = await apiCall(
        "POST",
        `/update-bonus-income`,
        body,
        true
      );
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        // toast.success(data.message || "Bonus income updated successfully!");
        setIncome("");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };

  return (
    <Container className="mt-4">
      <section id="change-password-section">
        <div className="d-flex justify-content-center">
          <h2>Update Bonus Income</h2>
        </div>
        <section id="formContent">
          <div className="form">
            <Row>
              <Col lg={6} style={{ margin: "auto" }}>
                <form onSubmit={handleUpdate}>
                  <div className="mb-3">
                    <label htmlFor="type">Type:</label>
                    <input
                      type="text"
                      id="type"
                      name="type"
                      className="form-control"
                      value="ROI Income"
                      disabled
                      readOnly
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="income">Income:</label>
                    <input
                      type="number"
                      id="income"
                      name="income"
                      className="form-control"
                      placeholder="Enter Income"
                      value={income}
                      onChange={(e) => setIncome(e.target.value)}
                      required
                    />
                  </div>
                  <Button type="submit" variant="primary">
                    Update
                  </Button>
                </form>
              </Col>
            </Row>
          </div>
        </section>
      </section>
    </Container>
  );
};

export default UpdateBonusIncome;
